// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import sortByProp from 'utils/MiscUtils/sortByProp'
import AssignmentItem from './AssignmentItem'
import styles from './index.scss'
import type {
  SectionWithAssignments_assignments as Assignments,
} from './__generated__/SectionWithAssignments_assignments.graphql'

type Props = $ReadOnly<{
  assignments: Assignments,
}>

const sortByName: <T>(T) => T = sortByProp('localizedName')

function SectionWithAssignments({assignments}: Props): Node {
  return (
    <li className="side-bar-section-item">
      <ul className={styles.roleList}>
        {sortByName(assignments).map((assignment) => (
          <AssignmentItem
            key={assignment.id}
            assignment={assignment}
          />
        ))}
      </ul>
    </li>
  )
}

export default (createFragmentContainer(SectionWithAssignments, {
  assignments: graphql`
    fragment SectionWithAssignments_assignments on Assignment @relay(plural: true) {
      id
      localizedName

      ...AssignmentItem_assignment
    }
  `,
}): RelayFragmentContainer<typeof(SectionWithAssignments)>)
